export const MIN_ALLOWED_AGE = 18;
export const MAX_ALLOWED_END_POLICY_AGE = 67;
export const MAX_ALLOWED_AGE = 62;
export const MIN_DISABILITY_INSURED_AMOUNT = 150;
export const MAX_DISABILITY_INSURED_AMOUNT = 2500;
export const MIN_ALLOWED_INSURANCE_DURATION = 5;
export const MAX_ALLOWED_INSURANCE_DURATION = 49;
export const MAX_ALLOWED_INSURANCE_DURATION_TEXT = 'Ingevoerde einddatum is niet mogelijk. De minimale looptijd is 5 jaar.';
export const MAX_ALLOWED_INSURED_AMOUNT_TEXT = 'Ingevoerd verzekerd bedrag is niet mogelijk. Vul een bedrag in tussen € 150 en € 2.500.';
export const MIN_ALLOWED_AGE_TEXT = 'De leeftijd voor het aangaan van deze verzekering ligt tussen 18 en 62 jaar.';
export const MAX_DISABILITY_INSURED_AMOUNT_TEXT = 'Ingevoerd verzekerd bedrag is niet mogelijk. Vul een bedrag in tussen € 150 en € 2.500 met ' +
    'een maximum van 125% van het verzekerd bedrag bij arbeidsongeschiktheid.';
export const MAX_ALLOWED_END_AGE_TEXT = 'Ingevoerde einddatum is niet mogelijk. ' +
    'Verander de einddatum tot uiterlijk de laatste dag van de maand vóór de maand waarin de verzekerde 67 wordt.';
